import React, { Component } from "react"
import { useErrorStore } from "store/useErrorStore"

// let clearError

// function initStoreRefs() {
//   clearError = () => useErrorStore.getState().clearError
// }

// initStoreRefs()

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }
  static getDerivedStateFromError(error) {
    return { hasError: true }
  }
  componentDidCatch(error, info) {
    console.error(error, info.componentStack)
  }
  componentWillUnmount() {
    const clearError = useErrorStore.getState().clearError
    clearError()
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback
    }

    return this.props.children
  }
}

export default ErrorBoundary
